import classNames from "classnames";
import { ComponentChildren, JSX } from "preact";

interface ItemWithIconProps {
  icon: string;
  iconSrc?: string
  title: string;
  description: string;
  accent?: boolean
  children?: JSX.Element
}

export function ItemWithIcon(props: ItemWithIconProps) {
  return <div class="item-with-icon">
    {/* TODO: Remove icon if all icon implemented */}
    <div class="icon">
      {props.iconSrc ? <img src={props.iconSrc} alt={props.title} class="benefit-icon" /> : (
        props.icon
      )}
    </div>
    <h3 class={classNames(props.accent && 'accent')}>{props.title}</h3>
    <p class={classNames(props.accent && 'accent')}>{props.description}</p>
    {props.children}
  </div>;
}

export function ItemWithIconGrid(props: { maxGrid?: 2 | 3 | 4, children: ComponentChildren }) {
  return <div class={classNames("item-with-icon-grid", `grid-${props.maxGrid ?? 3}`)}>
    {props.children}
  </div>
}